import { JarvisAuthProvider } from 'node_modules/@clientos/types/dist';
import { useMemo, useState } from 'react';
import { SubscriptionsOptionsClient } from 'src/services/SubscriptionOptionsClient';
import { Stack } from 'src/types/stratus';
import { SubscriptionOptionsResponse } from 'src/types/subscription';

const useSubscriptionOptions = (
  authProvider: JarvisAuthProvider,
  stack: Stack,
  bizlogicId: string,
  subscriptionId: string
): {
  loading: boolean;
  error: boolean;
  optionsData: any;
  fetchSubscriptionOptions: () => Promise<void>;
} => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [optionsData, setOptionsData] =
    useState<SubscriptionOptionsResponse | null>(null);

  const subscriptionOptionsClient = useMemo(
    () => new SubscriptionsOptionsClient(authProvider, stack, bizlogicId),
    [authProvider, stack, bizlogicId]
  );

  const fetchSubscriptionOptions = async () => {
    setLoading(true);
    try {
      const options =
        await subscriptionOptionsClient.getSubscriptionOptions(subscriptionId);
      setOptionsData(options);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(true);
      console.error(err);
    }
  };

  return {
    loading,
    error,
    optionsData,
    fetchSubscriptionOptions
  };
};

export default useSubscriptionOptions;
